// extracted by mini-css-extract-plugin
export default {"table":"Table_table__YUzYe","clearButton":"Table_clearButton__IoOfX","applyButton":"Table_applyButton__qW8iW"};